import { Box, Card, IconButton, Typography } from '@mui/material'

import { useEffect, useState } from 'react'
import WTypography from 'Components/whiteTypography'

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined'
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined'
import InterestsOutlinedIcon from '@mui/icons-material/InterestsOutlined'
import AddIcon from '@mui/icons-material/Add'
import QuestionAnswerFormRiskProfile from './QuestionAnswerFormRiskProfile'
import QuestionAnswerFormBase from './QuestionAnswerFormBase'
import QuestionAnswerFormProduit from './QuestionAnswerFormProduit'
import QuestionAnswerFormBourse from './QuestionAnswerFormBourse'
import QuestionAnswerFormImmobilier from './QuestionAnswerFormImmobilier'
import QuestionAnswerFinal from './QuestionAnswerFinal'
import FinanceInterest from './FinanceInterest'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setUserWizardDone } from 'reduxLib/slices/userSlice'
import { makePostRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function ProfilInvesti({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [openRiskProfile, setOpenRiskProfile] = useState(false)
  const [openFiKnowledge, setOpenFiKnowledge] = useState(-1)
  const [openFi, setOpenFi] = useState(false)
  let w_tfknowledge = localStorage.getItem('w-tfknowledge')
  let w_finterest = localStorage.getItem('w-finterest')
  let w_fprofile = sessionStorage.getItem('w-fprofile')
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    if (w_tfknowledge) {
      setOpenFiKnowledge(1)
    }
    if (w_finterest) {
      setOpenFi(true)
    }
    if (w_fprofile) {
      setOpenRiskProfile(true)
    }
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const questionnaire = params.get('questionnaire')

    if (
      location.hash === '#profil-risque' ||
      questionnaire === 'profil-risque' ||
      location.pathname.toLowerCase().endsWith('/profil-risque')
    ) {
      setOpenRiskProfile(true)
      return
    }

    if (
      location.hash === '#connaissance-financiere' ||
      questionnaire === 'connaissance-financiere' ||
      location.pathname.toLowerCase().endsWith('/connaissance-financiere')
    ) {
      setOpenFiKnowledge(1)
      return
    }

    if (
      location.hash === '#centres-interet-financier' ||
      questionnaire === 'centres-interet-financier' ||
      location.pathname.toLowerCase().endsWith('/centres-interet-financier')
    ) {
      setOpenFi(true)
    }
  }, [location.hash, location.pathname, location.search])
  useEffect(() => {
    if (w_tfknowledge) {
      if (openFiKnowledge === 0) {
        addAccDone()
      }
    }
  }, [openFiKnowledge])

  // const sleep = (ms) => {
  //     return new Promise((resolve) => setTimeout(resolve, ms))
  //   }
  const addAccDone = async () => {
    if (w_tfknowledge) {
      await makePostRequest(
        '/api/app/user-wizard/',
        { step: w_tfknowledge, completed: true, skip: true },
        {},
        true,
      )
      // await sleep(2000)
      dispatch(setUserWizardDone({ step: w_tfknowledge, completed: true, skip: true }))
      localStorage.removeItem('w-tfknowledge')
      navigate('/')
    }
  }
  return (
    <>
      {openRiskProfile && (
        <QuestionAnswerFormRiskProfile
          oldData={oldData}
          updateReports={updateReports}
          setOpenRiskProfile={setOpenRiskProfile}
        />
      )}
      {openFiKnowledge === 1 && (
        <QuestionAnswerFormBase
          updateReports={updateReports}
          setOpenFiKnowledge={setOpenFiKnowledge}
        />
      )}
      {openFiKnowledge === 2 && (
        <QuestionAnswerFormProduit
          updateReports={updateReports}
          setOpenFiKnowledge={setOpenFiKnowledge}
        />
      )}
      {openFiKnowledge === 3 && (
        <QuestionAnswerFormBourse
          updateReports={updateReports}
          setOpenFiKnowledge={setOpenFiKnowledge}
        />
      )}
      {openFiKnowledge === 4 && (
        <QuestionAnswerFormImmobilier
          updateReports={updateReports}
          setOpenFiKnowledge={setOpenFiKnowledge}
        />
      )}
      {openFiKnowledge === 5 && (
        <QuestionAnswerFinal
          updateReports={updateReports}
          setOpenFiKnowledge={setOpenFiKnowledge}
        />
      )}
      {openFi && <FinanceInterest updateReports={updateReports} setOpenFi={setOpenFi} />}

      <Card className="dashboard_card__root1" sx={{ position: 'relative', overflow: 'hidden' }}>
        {/* Halo décoratif */}
        <Box
          sx={{
            position: 'absolute',
            top: -70,
            right: -50,
            width: 170,
            height: 170,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(124,177,223,0.22), transparent 70%)',
            pointerEvents: 'none',
          }}
        />

        <Box className="dashboard_card__header1">
          <WTypography component={'span'} variant="h6">
            {t('monPatrimoine.investorProfile')}
          </WTypography>
        </Box>

        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1.25 }}>
          <ProfileSection
            icon={<ShieldOutlinedIcon />}
            accent="#7ab1df"
            label={t('monPatrimoine.risk')}
            onInfo={() => setOpenRiskProfile(true)}
          >
            {oldData?.risque_score ? (
              <ValueBadge color="#7ab1df" label={oldData.risque_score} />
            ) : (
              <NotSet label={t('monPatrimoine.notDefined')} />
            )}
          </ProfileSection>

          <ProfileSection
            icon={<SchoolOutlinedIcon />}
            accent="#7cc6b2"
            label={t('monPatrimoine.knowledge')}
            onInfo={() => setOpenFiKnowledge(1)}
          >
            {oldData?.financiere_score ? (
              <ValueBadge color="#7cc6b2" label={oldData.financiere_score} />
            ) : (
              <NotSet label={t('monPatrimoine.notDefined')} />
            )}
          </ProfileSection>

          <ProfileSection
            icon={<InterestsOutlinedIcon />}
            accent="#e0a458"
            label={t('monPatrimoine.elementsOfInterest')}
            onInfo={() => setOpenFi(true)}
          >
            {oldData?.finance_interest?.length > 0 ? (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                {oldData.finance_interest.map((el, index) => (
                  <Box
                    key={index}
                    sx={{
                      px: 1.1,
                      py: 0.4,
                      borderRadius: 999,
                      bgcolor: 'rgba(224,164,88,0.14)',
                      border: '1px solid rgba(224,164,88,0.32)',
                      color: '#fff',
                      fontSize: 12.5,
                      fontWeight: 700,
                    }}
                  >
                    {el}
                  </Box>
                ))}
              </Box>
            ) : (
              <Box
                onClick={() => setOpenFi(true)}
                onMouseDown={(e) => e.stopPropagation()}
                className="no-drag"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.5,
                  cursor: 'pointer',
                  color: '#e0a458',
                  fontSize: 13,
                  fontWeight: 700,
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                <AddIcon sx={{ fontSize: 16 }} />
                {t('monPatrimoine.selectFinancialInterests')}
              </Box>
            )}
          </ProfileSection>
        </Box>
      </Card>
    </>
  )
}

export default ProfilInvesti

// Bloc d'une dimension du profil investisseur (risque, connaissance, intérêts).
function ProfileSection({ icon, accent, label, onInfo, children }) {
  return (
    <Box
      sx={{
        bgcolor: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.07)',
        borderRadius: 2,
        p: 1.5,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box
          sx={{
            width: 34,
            height: 34,
            borderRadius: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: `${accent}24`,
            color: accent,
            '& svg': { fontSize: 18 },
          }}
        >
          {icon}
        </Box>
        <Typography
          sx={{
            flexGrow: 1,
            color: 'rgba(255,255,255,0.55)',
            fontSize: 11,
            fontWeight: 800,
            textTransform: 'uppercase',
            letterSpacing: 0.6,
          }}
        >
          {label}
        </Typography>
        <IconButton
          onClick={onInfo}
          onMouseDown={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
          className="no-drag"
          size="small"
          sx={{
            width: 26,
            height: 26,
            bgcolor: 'rgba(255,255,255,0.08)',
            color: '#cfe0f2',
            '&:hover': { bgcolor: 'rgba(255,255,255,0.18)' },
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 15 }} />
        </IconButton>
      </Box>
      <Box sx={{ mt: 1.25 }}>{children}</Box>
    </Box>
  )
}

// Pastille de valeur avec point coloré (niveau de risque, de connaissance…).
function ValueBadge({ color, label }) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.25,
        py: 0.5,
        borderRadius: 999,
        bgcolor: `${color}1f`,
        border: `1px solid ${color}40`,
      }}
    >
      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: color }} />
      <Typography sx={{ color: '#fff', fontSize: 14, fontWeight: 800 }}>
        {label}
      </Typography>
    </Box>
  )
}

// Valeur non renseignée (questionnaire pas encore complété).
function NotSet({ label }) {
  return (
    <Typography sx={{ color: 'rgba(255,255,255,0.4)', fontSize: 13, fontStyle: 'italic' }}>
      {label}
    </Typography>
  )
}
